{
  "steps": [
    "2.jpg",
    "4.jpg",
    "5.jpg",
    "6.jpg"
  ],
  "random": true
}